"use client";
import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ReactGA from "react-ga4";
import FeedbackModal from "@/components/modals/feedbackModal";
import { useDispatch } from "react-redux";
import { OpenFeedbackModal } from "./redux/slice";

import "@/app/styles/globals.scss";

const App = () => {
  const dispatch = useDispatch();
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  useEffect(() => {
    /* AOS.init({
      duration: 800,
    }); */
    ReactGA.initialize("G-JDZXMJWM2P");

    const feedbackModal = (userDataSelector) => {
      // console.log("inside feedback model");
      const userLoggedIn = localStorage.getItem("isUserLoggedIn");
      const feedbackStatus = localStorage.getItem("feedbackStatus");
      // console.log(userDataSelector, "userdata selector");
      if (userDataSelector && userLoggedIn) {
        if (
          Number(feedbackStatus) === 2 &&
          !userDataSelector.hasOwnProperty("rating")
        ) {
          // console.log("we are inside rating");
          setTimeout(() => {
            setOpenFeedbackModal(true);
          }, 5000);
        }
      }
    };

    dispatch(OpenFeedbackModal(feedbackModal));
  }, [dispatch]);

  /*   useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.type === "childList") {
          console.error("🔴 Hydration Mismatch Detected in:", mutation.target);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []); */

  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Disable key combinations
    const handleKeyDown = (e) => {
      const key = e.key.toLowerCase();

      // Disable Ctrl+Shift+S (screenshot)
      if (e.ctrlKey && e.shiftKey && key === "s") {
        e.preventDefault();
      }

      // Disable PrtSc key (PrintScreen)
      if (key === "printscreen") {
        e.preventDefault();
      }

      // Disable Ctrl+S (Save)
      if (e.ctrlKey && key === "s") {
        e.preventDefault();
      }

      // Disable Ctrl+Shift+I (Developer tools)
      /*   if (e.ctrlKey && e.shiftKey && key === "i") {
        e.preventDefault();
        alert("Ctrl+Shift+I is disabled");
      } */

      // Disable Ctrl+U (View source)
      if (e.ctrlKey && key === "u") {
        e.preventDefault();
      }
    };

    // Add event listeners
    // document.addEventListener("contextmenu", handleContextMenu);
    // document.addEventListener("keydown", handleKeyDown);

    // Cleanup event listeners on component unmount
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  /*  function fixViewportUnits() {
    let vh = window.innerHeight * 0.01;
    let vw = window.innerWidth * 0.01;

    document.documentElement.style.setProperty("--vh", `${vh}px`);
    document.documentElement.style.setProperty("--vw", `${vw}px`);
  }

  window.addEventListener("resize", fixViewportUnits);
  window.addEventListener("orientationchange", fixViewportUnits);
  fixViewportUnits(); */

  // viewport
  useEffect(() => {
    function fixViewportUnits() {
      let vh = window.innerHeight * 0.01;
      let vw = window.innerWidth * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
      document.documentElement.style.setProperty("--vw", `${vw}px`);
    }

    fixViewportUnits();
    window.addEventListener("resize", fixViewportUnits);
    window.addEventListener("orientationchange", fixViewportUnits);

    return () => {
      window.removeEventListener("resize", fixViewportUnits);
      window.removeEventListener("orientationchange", fixViewportUnits);
    };
  }, []);

  return (
    <>
      {/* feedback modal */}
      {openFeedbackModal && (
        <FeedbackModal setOpenFeedbackModal={setOpenFeedbackModal} />
      )}
    </>
  );
};

export default App;
